import { createContext, useContext, useState } from "react";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("folio-user") || sessionStorage.getItem("folio-user");
    return raw ? JSON.parse(raw) : null;
  });

  const [token, setToken] = useState(() => {
    return localStorage.getItem("folio-token") || sessionStorage.getItem("folio-token") || null;
  });

  const login = (userData, userToken, remember = true) => {
    setUser(userData);
    setToken(userToken);
    if (remember) {
      localStorage.setItem("folio-user", JSON.stringify(userData));
      localStorage.setItem("folio-token", userToken);
    } else {
      sessionStorage.setItem("folio-user", JSON.stringify(userData));
      sessionStorage.setItem("folio-token", userToken);
    }
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem("folio-user");
    localStorage.removeItem("folio-token");
    sessionStorage.removeItem("folio-user");
    sessionStorage.removeItem("folio-token");
  };

  return (
    <AuthContext.Provider
      value={{ user, token, isAuthenticated: !!user, login, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
